import React from 'react';
import { Link } from 'react-router-dom';
import { Gauge } from 'lucide-react';

import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { EmptyState } from '../ui/empty-state';
import { BarrePagination } from '../ui/pagination-bar';
import { usePagination } from '../../hooks/usePagination';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { maintenanceDateTime } from './MaintenanceTimeline';

const num = (value) => Number(value || 0);

/** Relevés compteur du camion: ce qui fait tomber les entretiens préventifs. */
export default function ReadingsTable({ readings = [] }) {
  const pagination = usePagination(readings, { cle: 'releves' });
  if (readings.length === 0) {
    return (
      <EmptyState
        variant="empty"
        icon={Gauge}
        title="Aucun relevé compteur"
        description="Le kilométrage relevé de temps en temps est ce qui déclenche les entretiens préventifs. Sans relevé, aucun plan de ce camion ne peut tomber à échéance."
        action={
          <Button size="sm" variant="outline" asChild>
            <Link to="/maintenance">Saisir un relevé</Link>
          </Button>
        }
      />
    );
  }

  return (
    <>
      <div className="overflow-hidden rounded-xl border border-border bg-card">
        <Table stickyFirstColumn>
          <TableHeader>
            <TableRow>
              <TableHead>Relevé le</TableHead>
              <TableHead>Compteur</TableHead>
              <TableHead>Origine</TableHead>
              <TableHead>Note</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {pagination.lignes.map((reading) => (
              <TableRow key={reading.id}>
                <TableCell>{maintenanceDateTime(reading.reading_date)}</TableCell>
                <TableCell className="font-mono tabular font-semibold">
                  {num(reading.value).toLocaleString('fr-FR')}{' '}
                  {reading.reading_type === 'hours' ? 'h' : 'km'}
                </TableCell>
                <TableCell>
                  <Badge variant="muted">
                    {reading.source === 'driver_app' ? 'Application chauffeur' : 'Saisie atelier'}
                  </Badge>
                </TableCell>
                <TableCell className="text-muted-foreground">{reading.note || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <BarrePagination pagination={pagination} nom="relevés" />
    </>
  );
}
